import React, { useEffect } from "react";
import { useContext } from "react";
import { CarrierContext } from "../contexts/CarrierContext";
import { LanguageContext } from "../contexts/LanguageContext";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/bootstrap5.3.min.css";
import "../assets/css/feather.css";
import "../assets/css/custom-file.css";
import "../assets/css/style.css";
//import "../assets/css/bootstrap-datetimepicker.css";

const Header = ({ condition }) => {
  const carrierContxt = useContext(CarrierContext);
  const langContext = useContext(LanguageContext);
  //  const [langLoader, setLangLoader] = useState(false);

  useEffect(() => {
    const urlCarrier = carrierContxt.hasOwnProperty("carrier") // Set URL in carrier
      ? carrierContxt.carrier
      : null;

    /* if (langContext.hasOwnProperty("loading")) {
      //Set Language loader
      setLangLoader(langContext.loading);
    } else {
      setLangLoader(false);
    }*/

    if (urlCarrier) {
      import("../assets/css/" + urlCarrier + "-styling.css")
        .then(() => {
          // Styles have been loaded
        })
        .catch((error) => {
          console.error("Failed to load CSS file", error);
        });
    }
  }, [carrierContxt, langContext]);
  return <></>;
  /* if (langLoader) {
    return (
      <div className="d-flex justify-content-center mt-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  } else {
    return <></>;
  }*/
};

export default Header;
